const sendPostAjax = (url, data, onSuccess, onError, params = {}) => {
    $.ajax(url, {
        method: 'POST',
        data,
        success: (e, status, res) => onSuccess ? onSuccess(e, status, res) : null,
        error: e => onError ? onError(e) : null,
        datatype: "application/x-www-form-urlencoded",
        ...params
    });
};

const sendGetAjax = (url, onSuccess, onError) => {
    $.ajax(url, {
        method: 'GET',
        success: (e, status, req) => onSuccess ? onSuccess(e, status, req) : null,
        error: e => onError ? onError(e) : null,
        datatype: "application/x-www-form-urlencoded"
    });
};

const sendPutAjax = (url, data, onSuccess, onError, params = {}) => {
    $.ajax(url, {
        method: 'PUT',
        data,
        success: e => onSuccess ? onSuccess(e) : null,
        error: e => onError ? onError(e) : null,
        datatype: "application/x-www-form-urlencoded",
        ...params
    });
};

const sendGetPromise = url => new Promise((resolve, reject) => sendGetAjax(url, resolve, reject));

const sendPostPromise = (url, data, params = {}) => new Promise((resolve, reject) => sendPostAjax(url, data, resolve, reject, params));

const sendPutPromise = (url, data, params = {}) => new Promise((resolve, reject) => sendPutAjax(url, data, resolve, reject, params))


export {
    sendPostAjax,
    sendGetAjax,
    sendPutAjax,
    sendGetPromise,
    sendPostPromise,
    sendPutPromise
};